import { AuthenticationContext } from "@/providers";
import { useContext } from "react";

export function useAuth() {
  const context = useContext(AuthenticationContext);
  if(!context) throw new Error("useAuthentication context error")
  return context;
}